<script setup>
  import ComponentIcon from "@components/Icons/Icon.vue";

  defineOptions({
    name: "ComponentUnsavedChanges",
  });

  defineProps({
    form: {
      type: Object,
      default: () => {
        return {
          processing: false,
          isDirty: false,
          recentlySuccessful: false,
        };
      },
    },
  });
</script>

<template>
  <div
    v-if="!form.processing && (form.isDirty || form.recentlySuccessful)"
    class="flex items-center space-x-1 self-center text-sm"
    :data-test="getTestId('unsaved-changes')"
  >
    <template v-if="form.isDirty">
      <component-icon class="text-mcred">warning_amber</component-icon>
      <span>Ungespeicherte Änderungen</span>
    </template>

    <template v-else>
      <component-icon class="text-mcgreen">check_circle</component-icon>
      <span>Gespeichert</span>
    </template>
  </div>
</template>
